var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "14px",
    viewBox: "0 0 6 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E58EF2AB-731F-45C6-A75F-20C29C604CC3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footers-#1",
    transform: "translate(-1297.000000, -511.000000)",
    fill: "#D8BE8D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copyright",
    transform: "translate(0.000000, 485.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-links",
    transform: "translate(1130.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.767123,7 L170.986301,7 L170.986301,14 L168.328767,14 L168.328767,7 L167,7 L167,4.58208955 L168.328767,4.58208955 L168.328767,3.13432836 C168.328767,1.17910448 169.082192,0 171.205479,0 L172.986301,0 L172.986301,2.41791045 L171.876712,2.41791045 C171.041096,2.41791045 170.986301,2.74626866 170.986301,3.37313433 L170.986301,4.58208955 L173,4.58208955 L172.767123,7 L172.767123,7 Z",
    id: "facebook-icon"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.b63d6db31228cce8c6ae3d26d0aaadd1.svg";
export { ForwardRef as ReactComponent };